import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/brands/brand-570.png")